import { KnownHubDetailsDtoType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { TowerDetails } from '../../../../../features/lockers/models/tower-details.model';
import { SectionDetails } from '../../../../../features/lockers/models/section-details.model';
import { LockerRenderData, TowerRenderData } from './tower-renderer.types';

/**
 * Maps TowerDetails (from hub details API) into TowerRenderData for the shared TowerRenderer.
 */
export function mapTowerDetailsToRenderData(tower: TowerDetails, hubType?: KnownHubDetailsDtoType): TowerRenderData {
  const lockers: LockerRenderData[] = tower.lockers.map((locker) => ({
    id: locker.id,
    name: locker.name,
    sizeName: locker.sizeName,
    sizeIcon: locker.sizeIcon,
    isKiosk: locker.isKiosk,
    pixelDimensions2D: locker.pixelDimensions2D,
    pixelPosition2D: locker.pixelPosition2D,
    invertedPixelPosition2D: locker.invertedPixelPosition2D,
    backgroundColor: locker.availabilityColor,
    highlightColor: locker.highlightColor
  }));

  return {
    id: tower.id,
    title: tower.title,
    pixelDimensions2D: tower.pixelDimensions2D,
    hubType,
    lockers
  };
}

/**
 * Maps SectionDetails (from hub details API) into TowerRenderData for the shared TowerRenderer.
 * Sections and towers share the same rendering structure (module with delivery containers inside).
 */
export function mapSectionDetailsToRenderData(section: SectionDetails): TowerRenderData {
  const lockers: LockerRenderData[] = section.spaces.map((space) => ({
    id: space.id,
    name: space.name,
    sizeName: 'space',
    sizeIcon: space.icon,
    isKiosk: space.isKiosk,
    pixelDimensions2D: space.pixelDimensions2D,
    pixelPosition2D: space.pixelPosition2D,
    backgroundColor: space.availabilityColor,
    highlightColor: space.highlightColor
  }));

  return {
    id: section.id,
    title: section.title,
    pixelDimensions2D: section.pixelDimensions2D,
    lockers
  };
}
